class DiskUsageDirective
  @$inject: ['$filter']
  constructor: ($filter)->       
    class DiskUsage      
      restrict: "AC"
      require: "^deviceUsage"
      controllerAs: "$disk"
      scope: true
      controller: ($scope)->
        @labels = ["Used", "Free"]

        @options =
          legend:
            display: true
            position: "bottom"            
            onClick: ()->

          tooltips:
            enabled: true
            callbacks:
              label: (item, data)->
                label = data.labels[item.index]
                data = data.datasets[0].data[item.index]
                msg =  "#{label}: #{$filter('bytes')(data)}"
                return msg
          # callbacks:
          # label: ()->
          #   console.log 'cl'
          # tooltipTemplate: (label) ->              
          #   msg =  "#{label.label}: #{$filter('bytes')(label.value)}"
          #   console.log msg
          # onAnimationComplete: (self) ->
          #   this.showTooltip(this.segments, true)  
        $scope.refresh = (usage)=>   
          {storage} = usage       
          @data = [storage.total - storage.free, storage.total] 

        return @
      link: ($scope, $element, $attrs, $usage)->
        $usage.register (usage)=>
          $scope.refresh(usage)

    return new DiskUsage()

  
module.exports = DiskUsageDirective


// WEBPACK FOOTER //
// ./src/component/device/usage/disk/index.coffee